export default class COSParser {
    constructor(config) {
        this.config = this.init(config);
    }
    init(config){
        if(typeof config === "object"){
            Object
                .keys(config)
                .forEach(key=>{
                    let temp = config[key];
                    let upperCaseKey = key.toUpperCase();
                    delete config[key];
                    config[upperCaseKey] = temp;
                })
        }
        return config;
    }
    makeInstruction([operator, index]) {
        operator = operator.toUpperCase();
        let opCodeExists = this.config.hasOwnProperty(operator);
        if(!opCodeExists){
            throw new Error("A Unexpected opcode was passed to the parser")
        }
        return {
            category: this.config[operator],
            index: index - 1,
        };
    }
    parseOrder(instructions) {
        let arrayFromInstructions = instructions.split(" ");
        arrayFromInstructions = arrayFromInstructions.filter(
            instruction => instruction !== ""
        );
        let toOperationArray = arrayFromInstructions.map(opCode => {
            const [operand, ...index] = Array.from(opCode);
            return [operand, Number(index.join(""))];
        });
        return toOperationArray.map(instruction =>
            this.makeInstruction(instruction)
        );
    }
}